const getters = {
    coupons: (state) => {
        return state.coupons
    },
    coupons_summary: (state) => {
        return state.coupons_summary
    }
}

export default getters
